import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// zh translations
import zhCommon from '../locales/zh/common.json';
import zhAuth from '../locales/zh/auth.json';
import zhDashboard from '../locales/zh/dashboard.json';
import zhStudio from '../locales/zh/studio.json';
import zhCreation from '../locales/zh/creation.json';
import zhCredits from '../locales/zh/credits.json';
import zhUsage from '../locales/zh/usage.json';
import zhHelp from '../locales/zh/help.json';
import zhLanding from '../locales/zh/landing.json';
import zhAutopilot from '../locales/zh/autopilot.json';

import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enDashboard from '../locales/en/dashboard.json';
import enStudio from '../locales/en/studio.json';
import enCreation from '../locales/en/creation.json';
import enCredits from '../locales/en/credits.json';
import enUsage from '../locales/en/usage.json';
import enHelp from '../locales/en/help.json';
import enLanding from '../locales/en/landing.json';
import enAutopilot from '../locales/en/autopilot.json';

const resources = {
  zh: {
    common: zhCommon,
    auth: zhAuth,
    dashboard: zhDashboard,
    studio: zhStudio,
    creation: zhCreation,
    credits: zhCredits,
    usage: zhUsage,
    help: zhHelp,
    landing: zhLanding,
    autopilot: zhAutopilot,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    studio: enStudio,
    creation: enCreation,
    credits: enCredits,
    usage: enUsage,
    help: enHelp,
    landing: enLanding,
    autopilot: enAutopilot,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    ns: [
      'common',
      'auth',
      'dashboard',
      'studio',
      'creation',
      'credits',
      'usage',
      'help',
      'landing',
      'autopilot',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
